import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Fragment, useContext } from 'react';
import cn from 'classnames';
import moment from 'moment';
import memoize from '@guestyci/memoize';
import { MomentFormatTypes } from "../utils";
import FormattedDate from "../FormattedDate";
import FormattedTime from "../FormattedTime";
import LocalizationContext from "../LocalizationProvider/LocalizationContext";
moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'seconds',
    ss: '%ss',
    m: 'a minute',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: 'a month',
    MM: '%dm',
    y: 'a year',
    yy: '%dy'
  }
});
var dateToFromNow = memoize(function (date, isEnglish) {
  if (isEnglish) {
    var diff = moment().diff(date, 'days');

    if (Math.abs(diff) !== 1) {
      return moment(date).fromNow();
    }

    return diff > 0 ? 'Yesterday' : 'Tomorrow';
  }

  return moment(date).fromNow();
});

var Moment = function Moment(_ref) {
  var date = _ref.date,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'muted' : _ref$color,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? MomentFormatTypes.Date : _ref$format,
      _ref$fromNow = _ref.fromNow,
      fromNow = _ref$fromNow === void 0 ? false : _ref$fromNow,
      _ref$humanize = _ref.humanize,
      humanize = _ref$humanize === void 0 ? false : _ref$humanize,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? undefined : _ref$variant;
  var Tag = variant || Fragment;

  var _useContext = useContext(LocalizationContext),
      isEnglish = _useContext.isEnglish;

  return React.createElement("div", {
    className: cn('d-flex moment-wrapper', _defineProperty({}, "text-".concat(color), color), className),
    style: style,
    "data-qa": "moment"
  }, fromNow || humanize ? React.createElement(Tag, null, dateToFromNow(date, isEnglish)) : React.createElement(React.Fragment, null, format === MomentFormatTypes.Time ? React.createElement(FormattedTime, {
    variant: variant,
    time: date
  }) : React.createElement(FormattedDate, {
    variant: variant,
    date: date,
    format: format
  })));
};

export default Moment;